
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "phase-4-hirer-identifiers"
    }}>{`Phase 4: Hirer identifiers`}</h1>
    <p>{`The SEEK API uses opaque `}<a parentName="p" {...{
        "href": "/graphql/seek-api-conventions#object-identifiers"
      }}>{`object identifier`}</a>{` strings to identify SEEK hirers.`}</p>
    <p>{`Your software may have been using numeric SEEK advertiser IDs for the previous version of Apply with SEEK.
As the `}<a parentName="p" {...{
        "href": "/guides/2024-revision/apply-with-seek"
      }}>{`new Apply with SEEK`}</a>{` is brought under the SEEK API,
this legacy format will be phased out to:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Simplify hirer onboarding,
as a single identifier can be used across all use cases`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Simplify partner integrations,
as your software won’t need to decide which identifier is applicable to which use case`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Improve the efficiency and reliability of partner integrations that called the SEEK API on demand to map between identifier formats`}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-diff",
        "metastring": "label=\"Identifier format change\"",
        "label": "\"Identifier",
        "format": true,
        "change\"": true
      }}>{`- 10000
+ seekAnzPublicTest:organization:seek:93WyyF1h
`}</code></pre>
    <h2 {...{
      "id": "migration-considerations"
    }}>{`Migration considerations`}</h2>
    <h3 {...{
      "id": "converting-existing-ids"
    }}>{`Converting existing IDs`}</h3>
    <p>{`If your software currently stores SEEK advertiser IDs,
download a CSV of your SEEK hirers from the `}<a parentName="p" {...{
        "href": "/manage/hirers"
      }}>{`Developer Dashboard’s hirers page`}</a>{`.
This includes a mapping between legacy SEEK advertiser IDs and new hirer IDs.`}</p>
    <h3 {...{
      "id": "onboarding-new-hirers"
    }}>{`Onboarding new hirers`}</h3>
    <p>{`SEEK’s hirer onboarding process already provides your software with our new hirer IDs.`}</p>
    <p>{`Ensure that any corresponding changes made to your software and processes comply with our `}<a parentName="p" {...{
        "href": "/auth/hirer-relationships#hirer-onboarding"
      }}>{`hirer onboarding guidance`}</a>{` by enforcing appropriate authorization and validation.`}</p>
    <h2 {...{
      "id": "exit-criteria"
    }}>{`Exit criteria`}</h2>
    <p>{`At the conclusion of this revision,
your software must internally operate on our new hirer IDs.`}</p>
    <p>{`Support for the `}<a parentName="p" {...{
        "href": "https://developer.seek.com/schema/#/query/seekAnzAdvertiser"
      }}><inlineCode parentName="a">{`seekAnzAdvertiser`}</inlineCode>{` query`}</a>{` and related fields across the GraphQL schema will be removed.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;